import * as yup from "yup";

import { defaultCountry } from "../../shared";

export function onlyIfFieldIsVisibleProvince(
  this: yup.StringSchema,
  validator: yup.StringSchema
): yup.StringSchema {
  return this.test("only-if-field-is-visible-province", function (val) {
    if (
      val === undefined ||
      this.parent?.country?.value !== defaultCountry.value
    ) {
      return true;
    }

    try {
      validator.validateSync(val);
      return true;
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      return this.createError({ message, path: this.path });
    }
  });
}
